import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"
import localizedFormat from "dayjs/plugin/localizedFormat"
import utc from "dayjs/plugin/utc"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
import calendar from "dayjs/plugin/calendar"

dayjs.extend(localizedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(isSameOrAfter)
dayjs.extend(calendar)
dayjs.locale("en")

export default dayjs
